import { combineReducers } from '@reduxjs/toolkit'
import user from './slice/user'
import data from './slice/data'
import currentItem from './slice/currentItem'

const reducer = combineReducers({
  user,
  data,
  currentItem
})

export default reducer
